// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3YeC6","colMaxWidth":"Table_colMaxWidth__30jyl"};